import { render } from "./justificativas.vue?vue&type=template&id=0666994e&scoped=true"
import script from "./justificativas.vue?vue&type=script&lang=js"
export * from "./justificativas.vue?vue&type=script&lang=js"

import "./justificativas.vue?vue&type=style&index=0&id=0666994e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0666994e"]])

export default __exports__